interface FetchLeaderboardDataParams {
    api: any;
    eventID: string;
    refDate: Date;
    currentLeaderboardData: any[];
}

interface FetchLeaderboardDataResult {
    updatedLeaderboardData: any[];
    leaderBoardCourseData: any;
    eventInfo: any | null;
}

export const fetchLeaderboardData = async ({
    api,
    eventID,
    refDate,
    currentLeaderboardData
}: FetchLeaderboardDataParams): Promise<FetchLeaderboardDataResult> => {
    
    const response = await api.get('/lb/GetLeaderboardData', {
        params: {
            eventID: eventID,
            refDate: refDate
        }
    });

    console.log('Response:', response.data);

    const data = response.data;

    let updatedLeaderboardData;

    if (currentLeaderboardData.length > 0) {
        // Update existing leaderboardData with new data
        updatedLeaderboardData = currentLeaderboardData.map((item: any) => {
            const matchingEntry = data.eventScores.find((newItem: any) => newItem._id === item._id);
            return matchingEntry ? matchingEntry : item;
        });
    } else {
        // Add new leaderboardData
        updatedLeaderboardData = data.eventScores;
    }

    return {
        updatedLeaderboardData,
        leaderBoardCourseData: data.leaderBoardCourseData,
        eventInfo: data.eventInfo ?? null,
    };
}

